import { render, staticRenderFns } from "./client_date.vue?vue&type=template&id=72fa18dd"
import script from "./client_date.vue?vue&type=script&lang=js"
export * from "./client_date.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports